export default __webpack_public_path__ + "static/media/050-fire-alarm.1d416f31.png";